const { Swiper } = require("swiper/bundle");

(function ($) {
  function initReviewsSliderSm() {
    let reviewsSliderSm = new Swiper(".rr-reviews__slider--sm", {
      slidesPerView: 1,
      autoHeight: true,
      spaceBetween: 20,
      loop: true,
      loopFillGroupWithBlank: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }

  if($(".rr-reviews__slider--sm")){
    initReviewsSliderSm();
  }

  // lg slider
  if($(".rr-reviews__slider--lg")){
    $(".rr-reviews__slider--lg .rr-reviews__list-item").on("click", function () {
      $(this)
        .closest(".rr-reviews__wrap")
        .find(".rr-reviews__review")
        .removeClass("rr-reviews__review--expanded");

      $(this)
        .find(".rr-reviews__review")
        .addClass("rr-reviews__review--expanded");

      let id = $(this).data("expand");

      if (id) {
        $(this)
          .closest(".rr-reviews__wrap")
          .find(".rr-reviews__preview")
          .children(".rr-reviews__review")
          .removeClass("rr-reviews__review--active");

        $(this)
          .closest(".rr-reviews__wrap")
          .find(".rr-reviews__preview")
          .children("#" + id)
          .addClass("rr-reviews__review--active");
      }
    });
  }
})(jQuery);
